import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

import './style.scss';

export const AttachModal = ({
  setOpenTeacherAttachModal,
  selectedTeacher,
  onTeacherChange,
  listTeachers,
  onAttachStudent,
}) => {
  const { t } = useTranslation();

  return (
    <div className="student-attach-overlay" onClick={() => setOpenTeacherAttachModal(false)}>
      <div className="popup-send-homework-content student-attach" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{t('teacher responsible for the subject')}</h3>

          <button className="btn btn-icon" onClick={() => setOpenTeacherAttachModal(false)}>
            <span className="icon icon-plus"></span>
          </button>
        </div>

        <div className="wrap-select-send">
          <Autocomplete
            id="student-hw-select"
            options={listTeachers
              .filter(teacher => teacher && teacher.FIO)
              .sort((a, b) => a.FIO.localeCompare(b.FIO))
              .map(teacher => teacher.FIO)}
            value={selectedTeacher}
            onChange={(event, newValue) => onTeacherChange(newValue)}
            renderInput={params => <TextField {...params} label={t('select a teacher')} />}
          />
        </div>

        <div className="button-send-row">
          <button className="btn btn-primary more attach-btn" onClick={onAttachStudent}>
            <span>{t('appoint')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
